// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, "#room-schedule-setting-edit[data-v-03eb7fb4]{max-width:800px;margin-left:auto;margin-right:auto}#room-schedule-setting-edit .cancel-btn[data-v-03eb7fb4],#room-schedule-setting-edit .update-btn[data-v-03eb7fb4]{width:120px}", ""]);
// Exports
export default ___CSS_LOADER_EXPORT___;
